export const contactsData = [
  {
    id: 1,
    contactName: 'Alex Johnson',
    firstName: 'Alex',
    lastName: 'Johnson',
    email: 'alex.johnson@techsolutions.com',
    phone: '+1-555-123-4567',
    mobilePhone: '+1-555-987-6543',
    jobTitle: 'Chief Executive Officer',
    department: 'Executive',
    company: 'Tech Solutions Inc',
    companySize: 'Large (500+)',
    industry: 'Technology',
    address: '789 Business Blvd, Austin, TX 78701',
    city: 'Austin',
    state: 'Texas',
    zipCode: '78701',
    country: 'USA',
    website: 'https://techsolutions.com',
    linkedin: 'https://linkedin.com/in/alexjohnson',
    status: 'Active',
    contactType: 'Customer',
    leadSource: 'Website',
    lastContactDate: '2024-01-25',
    nextFollowUp: '2024-02-01',
    createdAt: '2024-01-15',
    assignedTo: 'John Smith',
    tags: ['VIP', 'Decision Maker', 'Enterprise'],
    notes: 'Primary contact for enterprise deals',
    preferredContact: 'Email',
    timeZone: 'CST',
    birthday: '1985-03-15',
    isSubscribed: true,
    revenue: 125000,
    lastPurchase: '2024-01-20'
  },
  {
    id: 2,
    contactName: 'Sarah Miller',
    firstName: 'Sarah',
    lastName: 'Miller',
    email: 'sarah.miller@startup.com',
    phone: '+1-555-234-5678',
    mobilePhone: '+1-555-876-5432',
    jobTitle: 'Marketing Director',
    department: 'Marketing',
    company: 'Startup Innovations',
    companySize: 'Medium (50-200)',
    industry: 'Marketing',
    address: '321 Innovation Dr, Seattle, WA 98101',
    city: 'Seattle',
    state: 'Washington',
    zipCode: '98101',
    country: 'USA',
    website: 'https://startupinnovations.com',
    linkedin: 'https://linkedin.com/in/sarahmiller',
    status: 'Active',
    contactType: 'Prospect',
    leadSource: 'LinkedIn',
    lastContactDate: '2024-01-24',
    nextFollowUp: '2024-01-30',
    createdAt: '2024-01-10',
    assignedTo: 'Emma Wilson',
    tags: ['Marketing', 'Warm Lead'],
    notes: 'Interested in marketing automation tools',
    preferredContact: 'Phone',
    timeZone: 'PST',
    birthday: '1988-07-22',
    isSubscribed: true,
    revenue: 85000,
    lastPurchase: '2024-01-18'
  },
  {
    id: 3,
    contactName: 'Michael Chen',
    firstName: 'Michael',
    lastName: 'Chen',
    email: 'michael.chen@techcorp.com',
    phone: '+1-555-345-6789',
    mobilePhone: '+1-555-765-4321',
    jobTitle: 'Chief Technology Officer',
    department: 'Technology',
    company: 'TechCorp Solutions',
    companySize: 'Large (500+)',
    industry: 'Software',
    address: '456 Tech Lane, San Francisco, CA 94105',
    city: 'San Francisco',
    state: 'California',
    zipCode: '94105',
    country: 'USA',
    website: 'https://techcorp.com',
    linkedin: 'https://linkedin.com/in/michaelchen',
    status: 'Pending',
    contactType: 'Lead',
    leadSource: 'Referral',
    lastContactDate: '2024-01-20',
    nextFollowUp: '2024-01-28',
    createdAt: '2024-01-05',
    assignedTo: 'David Brown',
    tags: ['Technical', 'Decision Maker'],
    notes: 'Technical evaluation in progress',
    preferredContact: 'Email',
    timeZone: 'PST',
    birthday: '1982-11-08',
    isSubscribed: false,
    revenue: 0,
    lastPurchase: null
  },
  {
    id: 4,
    contactName: 'Emily Rodriguez',
    firstName: 'Emily',
    lastName: 'Rodriguez',
    email: 'emily.rodriguez@globalcorp.com',
    phone: '+1-555-456-7890',
    mobilePhone: '+1-555-654-3210',
    jobTitle: 'VP of Sales',
    department: 'Sales',
    company: 'Global Corp',
    companySize: 'Enterprise (1000+)',
    industry: 'Finance',
    address: '123 Corporate Ave, New York, NY 10001',
    city: 'New York',
    state: 'New York',
    zipCode: '10001',
    country: 'USA',
    website: 'https://globalcorp.com',
    linkedin: 'https://linkedin.com/in/emilyrodriguez',
    status: 'Active',
    contactType: 'Customer',
    leadSource: 'Cold Call',
    lastContactDate: '2024-01-23',
    nextFollowUp: '2024-02-05',
    createdAt: '2023-12-20',
    assignedTo: 'Lisa Anderson',
    tags: ['Enterprise', 'High Value', 'Finance'],
    notes: 'Key decision maker for large deals',
    preferredContact: 'Phone',
    timeZone: 'EST',
    birthday: '1979-05-12',
    isSubscribed: true,
    revenue: 250000,
    lastPurchase: '2024-01-15'
  },
  {
    id: 5,
    contactName: 'James Wilson',
    firstName: 'James',
    lastName: 'Wilson',
    email: 'james.wilson@innovatetech.com',
    phone: '+1-555-567-8901',
    mobilePhone: '+1-555-543-2109',
    jobTitle: 'Product Manager',
    department: 'Product',
    company: 'InnovateTech',
    companySize: 'Medium (50-200)',
    industry: 'Technology',
    address: '789 Innovation Blvd, Boston, MA 02101',
    city: 'Boston',
    state: 'Massachusetts',
    zipCode: '02101',
    country: 'USA',
    website: 'https://innovatetech.com',
    linkedin: 'https://linkedin.com/in/jameswilson',
    status: 'Active',
    contactType: 'Prospect',
    leadSource: 'Trade Show',
    lastContactDate: '2024-01-22',
    nextFollowUp: '2024-01-29',
    createdAt: '2024-01-08',
    assignedTo: 'Michael Davis',
    tags: ['Product', 'Innovation', 'Tech'],
    notes: 'Interested in product integration solutions',
    preferredContact: 'Email',
    timeZone: 'EST',
    birthday: '1990-09-18',
    isSubscribed: true,
    revenue: 45000,
    lastPurchase: '2024-01-10'
  },
  {
    id: 6,
    contactName: 'Lisa Thompson',
    firstName: 'Lisa',
    lastName: 'Thompson',
    email: 'lisa.thompson@healthplus.com',
    phone: '+1-555-678-9012',
    mobilePhone: '+1-555-432-1098',
    jobTitle: 'Operations Director',
    department: 'Operations',
    company: 'HealthPlus Solutions',
    companySize: 'Large (500+)',
    industry: 'Healthcare',
    address: '456 Medical Center Dr, Chicago, IL 60601',
    city: 'Chicago',
    state: 'Illinois',
    zipCode: '60601',
    country: 'USA',
    website: 'https://healthplus.com',
    linkedin: 'https://linkedin.com/in/lisathompson',
    status: 'Pending',
    contactType: 'Lead',
    leadSource: 'Website',
    lastContactDate: '2024-01-21',
    nextFollowUp: '2024-01-31',
    createdAt: '2024-01-12',
    assignedTo: 'Sarah Jones',
    tags: ['Healthcare', 'Operations', 'Director'],
    notes: 'Evaluating healthcare management solutions',
    preferredContact: 'Phone',
    timeZone: 'CST',
    birthday: '1983-12-03',
    isSubscribed: false,
    revenue: 0,
    lastPurchase: null
  },
  {
    id: 7,
    contactName: 'Robert Davis',
    firstName: 'Robert',
    lastName: 'Davis',
    email: 'robert.davis@financepro.com',
    phone: '+1-555-789-0123',
    mobilePhone: '+1-555-321-0987',
    jobTitle: 'CFO',
    department: 'Finance',
    company: 'Finance Pro Inc',
    companySize: 'Medium (50-200)',
    industry: 'Finance',
    address: '321 Wall Street, New York, NY 10005',
    city: 'New York',
    state: 'New York',
    zipCode: '10005',
    country: 'USA',
    website: 'https://financepro.com',
    linkedin: 'https://linkedin.com/in/robertdavis',
    status: 'Active',
    contactType: 'Customer',
    leadSource: 'Referral',
    lastContactDate: '2024-01-26',
    nextFollowUp: '2024-02-02',
    createdAt: '2023-11-15',
    assignedTo: 'Tom Wilson',
    tags: ['Finance', 'CFO', 'Decision Maker'],
    notes: 'Long-term customer with growing needs',
    preferredContact: 'Email',
    timeZone: 'EST',
    birthday: '1975-08-27',
    isSubscribed: true,
    revenue: 180000,
    lastPurchase: '2024-01-12'
  },
  {
    id: 8,
    contactName: 'Jennifer Garcia',
    firstName: 'Jennifer',
    lastName: 'Garcia',
    email: 'jennifer.garcia@retailmax.com',
    phone: '+1-555-890-1234',
    mobilePhone: '+1-555-210-9876',
    jobTitle: 'Store Manager',
    department: 'Retail',
    company: 'RetailMax',
    companySize: 'Large (500+)',
    industry: 'Retail',
    address: '789 Shopping Center, Los Angeles, CA 90210',
    city: 'Los Angeles',
    state: 'California',
    zipCode: '90210',
    country: 'USA',
    website: 'https://retailmax.com',
    linkedin: 'https://linkedin.com/in/jennifergarcia',
    status: 'Active',
    contactType: 'Prospect',
    leadSource: 'Social Media',
    lastContactDate: '2024-01-24',
    nextFollowUp: '2024-02-03',
    createdAt: '2024-01-18',
    assignedTo: 'Alex Chen',
    tags: ['Retail', 'Manager', 'West Coast'],
    notes: 'Interested in retail management solutions',
    preferredContact: 'Phone',
    timeZone: 'PST',
    birthday: '1987-04-14',
    isSubscribed: true,
    revenue: 65000,
    lastPurchase: '2024-01-22'
  },
  {
    id: 9,
    contactName: 'David Brown',
    firstName: 'David',
    lastName: 'Brown',
    email: 'david.brown@edutech.com',
    phone: '+1-555-901-2345',
    mobilePhone: '+1-555-109-8765',
    jobTitle: 'Academic Director',
    department: 'Education',
    company: 'EduTech Solutions',
    companySize: 'Medium (50-200)',
    industry: 'Education',
    address: '456 University Ave, Cambridge, MA 02138',
    city: 'Cambridge',
    state: 'Massachusetts',
    zipCode: '02138',
    country: 'USA',
    website: 'https://edutech.com',
    linkedin: 'https://linkedin.com/in/davidbrown',
    status: 'Pending',
    contactType: 'Lead',
    leadSource: 'Email Campaign',
    lastContactDate: '2024-01-19',
    nextFollowUp: '2024-01-26',
    createdAt: '2024-01-03',
    assignedTo: 'Rachel Green',
    tags: ['Education', 'Academic', 'Director'],
    notes: 'Looking for educational technology solutions',
    preferredContact: 'Email',
    timeZone: 'EST',
    birthday: '1981-10-30',
    isSubscribed: false,
    revenue: 0,
    lastPurchase: null
  },
  {
    id: 10,
    contactName: 'Amanda White',
    firstName: 'Amanda',
    lastName: 'White',
    email: 'amanda.white@consulting.com',
    phone: '+1-555-012-3456',
    mobilePhone: '+1-555-098-7654',
    jobTitle: 'Senior Consultant',
    department: 'Consulting',
    company: 'Consulting Group',
    companySize: 'Small (10-50)',
    industry: 'Consulting',
    address: '123 Business Park, Denver, CO 80202',
    city: 'Denver',
    state: 'Colorado',
    zipCode: '80202',
    country: 'USA',
    website: 'https://consultinggroup.com',
    linkedin: 'https://linkedin.com/in/amandawhite',
    status: 'Active',
    contactType: 'Customer',
    leadSource: 'Partner Referral',
    lastContactDate: '2024-01-25',
    nextFollowUp: '2024-02-08',
    createdAt: '2023-10-22',
    assignedTo: 'Kevin Lee',
    tags: ['Consulting', 'Senior', 'Partner'],
    notes: 'Strategic consulting partner',
    preferredContact: 'Phone',
    timeZone: 'MST',
    birthday: '1984-06-08',
    isSubscribed: true,
    revenue: 95000,
    lastPurchase: '2024-01-14'
  },
  // Continue with remaining 90 contacts...
  {
    id: 11,
    contactName: 'Christopher Lee',
    firstName: 'Christopher',
    lastName: 'Lee',
    email: 'christopher.lee@manufacturing.com',
    phone: '+1-555-223-4567',
    mobilePhone: '+1-555-887-6543',
    jobTitle: 'Production Manager',
    department: 'Manufacturing',
    company: 'Manufacturing Corp',
    companySize: 'Large (500+)',
    industry: 'Manufacturing',
    address: '789 Industrial Blvd, Detroit, MI 48201',
    city: 'Detroit',
    state: 'Michigan',
    zipCode: '48201',
    country: 'USA',
    website: 'https://manufacturing.com',
    linkedin: 'https://linkedin.com/in/christopherlee',
    status: 'Inactive',
    contactType: 'Former Customer',
    leadSource: 'Trade Show',
    lastContactDate: '2023-12-15',
    nextFollowUp: '2024-02-15',
    createdAt: '2023-08-10',
    assignedTo: 'Maria Garcia',
    tags: ['Manufacturing', 'Production', 'Industrial'],
    notes: 'Former customer - potential for re-engagement',
    preferredContact: 'Email',
    timeZone: 'EST',
    birthday: '1978-01-25',
    isSubscribed: false,
    revenue: 0,
    lastPurchase: '2023-11-30'
  },
  {
    id: 12,
    contactName: 'Michelle Taylor',
    firstName: 'Michelle',
    lastName: 'Taylor',
    email: 'michelle.taylor@nonprofit.org',
    phone: '+1-555-334-5678',
    mobilePhone: '+1-555-776-5432',
    jobTitle: 'Program Director',
    department: 'Programs',
    company: 'NonProfit Organization',
    companySize: 'Small (10-50)',
    industry: 'Non-Profit',
    address: '456 Community St, Portland, OR 97201',
    city: 'Portland',
    state: 'Oregon',
    zipCode: '97201',
    country: 'USA',
    website: 'https://nonprofit.org',
    linkedin: 'https://linkedin.com/in/michelletaylor',
    status: 'Active',
    contactType: 'Prospect',
    leadSource: 'Website',
    lastContactDate: '2024-01-23',
    nextFollowUp: '2024-01-30',
    createdAt: '2024-01-16',
    assignedTo: 'Chris Johnson',
    tags: ['Non-Profit', 'Programs', 'Community'],
    notes: 'Interested in donor management solutions',
    preferredContact: 'Email',
    timeZone: 'PST',
    birthday: '1989-03-17',
    isSubscribed: true,
    revenue: 25000,
    lastPurchase: '2024-01-20'
  },
  {
    id: 13,
    contactName: 'Kevin Martinez',
    firstName: 'Kevin',
    lastName: 'Martinez',
    email: 'kevin.martinez@realestate.com',
    phone: '+1-555-445-6789',
    mobilePhone: '+1-555-665-4321',
    jobTitle: 'Real Estate Broker',
    department: 'Sales',
    company: 'Real Estate Partners',
    companySize: 'Medium (50-200)',
    industry: 'Real Estate',
    address: '321 Property Ave, Miami, FL 33101',
    city: 'Miami',
    state: 'Florida',
    zipCode: '33101',
    country: 'USA',
    website: 'https://realestate.com',
    linkedin: 'https://linkedin.com/in/kevinmartinez',
    status: 'Active',
    contactType: 'Customer',
    leadSource: 'Referral',
    lastContactDate: '2024-01-26',
    nextFollowUp: '2024-02-05',
    createdAt: '2023-09-12',
    assignedTo: 'Anna Rodriguez',
    tags: ['Real Estate', 'Broker', 'Sales'],
    notes: 'High-volume real estate professional',
    preferredContact: 'Phone',
    timeZone: 'EST',
    birthday: '1986-11-22',
    isSubscribed: true,
    revenue: 135000,
    lastPurchase: '2024-01-18'
  },
  {
    id: 14,
    contactName: 'Rachel Green',
    firstName: 'Rachel',
    lastName: 'Green',
    email: 'rachel.green@logistics.com',
    phone: '+1-555-556-7890',
    mobilePhone: '+1-555-554-3210',
    jobTitle: 'Logistics Coordinator',
    department: 'Operations',
    company: 'Logistics Solutions',
    companySize: 'Large (500+)',
    industry: 'Logistics',
    address: '789 Distribution Dr, Houston, TX 77001',
    city: 'Houston',
    state: 'Texas',
    zipCode: '77001',
    country: 'USA',
    website: 'https://logistics.com',
    linkedin: 'https://linkedin.com/in/rachelgreen',
    status: 'Pending',
    contactType: 'Lead',
    leadSource: 'LinkedIn',
    lastContactDate: '2024-01-22',
    nextFollowUp: '2024-01-29',
    createdAt: '2024-01-11',
    assignedTo: 'Steve Martinez',
    tags: ['Logistics', 'Operations', 'Coordination'],
    notes: 'Evaluating supply chain management tools',
    preferredContact: 'Email',
    timeZone: 'CST',
    birthday: '1992-07-05',
    isSubscribed: false,
    revenue: 0,
    lastPurchase: null
  },
  {
    id: 15,
    contactName: 'Steven Anderson',
    firstName: 'Steven',
    lastName: 'Anderson',
    email: 'steven.anderson@insurance.com',
    phone: '+1-555-667-8901',
    mobilePhone: '+1-555-443-2109',
    jobTitle: 'Insurance Agent',
    department: 'Sales',
    company: 'Insurance Group',
    companySize: 'Medium (50-200)',
    industry: 'Insurance',
    address: '456 Policy Lane, Phoenix, AZ 85001',
    city: 'Phoenix',
    state: 'Arizona',
    zipCode: '85001',
    country: 'USA',
    website: 'https://insurance.com',
    linkedin: 'https://linkedin.com/in/stevenanderson',
    status: 'Active',
    contactType: 'Prospect',
    leadSource: 'Cold Call',
    lastContactDate: '2024-01-24',
    nextFollowUp: '2024-02-01',
    createdAt: '2024-01-14',
    assignedTo: 'Jennifer Lee',
    tags: ['Insurance', 'Agent', 'Sales'],
    notes: 'Interested in CRM solutions for agents',
    preferredContact: 'Phone',
    timeZone: 'MST',
    birthday: '1980-12-11',
    isSubscribed: true,
    revenue: 55000,
    lastPurchase: '2024-01-16'
  },
  {
    id: 16,
    contactName: 'Nicole Wilson',
    firstName: 'Nicole',
    lastName: 'Wilson',
    email: 'nicole.wilson@architecture.com',
    phone: '+1-555-778-9012',
    mobilePhone: '+1-555-332-1098',
    jobTitle: 'Senior Architect',
    department: 'Design',
    company: 'Architecture Firm',
    companySize: 'Small (10-50)',
    industry: 'Architecture',
    address: '123 Design Plaza, San Diego, CA 92101',
    city: 'San Diego',
    state: 'California',
    zipCode: '92101',
    country: 'USA',
    website: 'https://architecture.com',
    linkedin: 'https://linkedin.com/in/nicolewilson',
    status: 'Active',
    contactType: 'Customer',
    leadSource: 'Website',
    lastContactDate: '2024-01-25',
    nextFollowUp: '2024-02-06',
    createdAt: '2023-12-08',
    assignedTo: 'Mark Thompson',
    tags: ['Architecture', 'Design', 'Creative'],
    notes: 'Uses design collaboration tools',
    preferredContact: 'Email',
    timeZone: 'PST',
    birthday: '1985-09-03',
    isSubscribed: true,
    revenue: 75000,
    lastPurchase: '2024-01-11'
  },
  {
    id: 17,
    contactName: 'Daniel Clark',
    firstName: 'Daniel',
    lastName: 'Clark',
    email: 'daniel.clark@hospitality.com',
    phone: '+1-555-889-0123',
    mobilePhone: '+1-555-221-0987',
    jobTitle: 'Hotel Manager',
    department: 'Operations',
    company: 'Hospitality Group',
    companySize: 'Large (500+)',
    industry: 'Hospitality',
    address: '789 Resort Blvd, Las Vegas, NV 89101',
    city: 'Las Vegas',
    state: 'Nevada',
    zipCode: '89101',
    country: 'USA',
    website: 'https://hospitality.com',
    linkedin: 'https://linkedin.com/in/danielclark',
    status: 'Pending',
    contactType: 'Lead',
    leadSource: 'Trade Show',
    lastContactDate: '2024-01-21',
    nextFollowUp: '2024-01-28',
    createdAt: '2024-01-07',
    assignedTo: 'Laura Davis',
    tags: ['Hospitality', 'Hotel', 'Manager'],
    notes: 'Evaluating guest management systems',
    preferredContact: 'Phone',
    timeZone: 'PST',
    birthday: '1977-05-29',
    isSubscribed: false,
    revenue: 0,
    lastPurchase: null
  },
  {
    id: 18,
    contactName: 'Laura Robinson',
    firstName: 'Laura',
    lastName: 'Robinson',
    email: 'laura.robinson@media.com',
    phone: '+1-555-990-1234',
    mobilePhone: '+1-555-110-9876',
    jobTitle: 'Content Manager',
    department: 'Marketing',
    company: 'Media Solutions',
    companySize: 'Medium (50-200)',
    industry: 'Media',
    address: '456 Creative Ave, Nashville, TN 37201',
    city: 'Nashville',
    state: 'Tennessee',
    zipCode: '37201',
    country: 'USA',
    website: 'https://media.com',
    linkedin: 'https://linkedin.com/in/laurarobinson',
    status: 'Active',
    contactType: 'Prospect',
    leadSource: 'Social Media',
    lastContactDate: '2024-01-23',
    nextFollowUp: '2024-02-02',
    createdAt: '2024-01-09',
    assignedTo: 'Peter Wilson',
    tags: ['Media', 'Content', 'Creative'],
    notes: 'Interested in content management solutions',
    preferredContact: 'Email',
    timeZone: 'CST',
    birthday: '1991-02-14',
    isSubscribed: true,
    revenue: 40000,
    lastPurchase: '2024-01-19'
  },
  {
    id: 19,
    contactName: 'Mark Phillips',
    firstName: 'Mark',
    lastName: 'Phillips',
    email: 'mark.phillips@energy.com',
    phone: '+1-555-801-2345',
    mobilePhone: '+1-555-009-8765',
    jobTitle: 'Energy Analyst',
    department: 'Research',
    company: 'Energy Corp',
    companySize: 'Large (500+)',
    industry: 'Energy',
    address: '321 Power St, Dallas, TX 75201',
    city: 'Dallas',
    state: 'Texas',
    zipCode: '75201',
    country: 'USA',
    website: 'https://energy.com',
    linkedin: 'https://linkedin.com/in/markphillips',
    status: 'Active',
    contactType: 'Customer',
    leadSource: 'Partner Referral',
    lastContactDate: '2024-01-26',
    nextFollowUp: '2024-02-09',
    createdAt: '2023-07-19',
    assignedTo: 'Sophie Chen',
    tags: ['Energy', 'Analyst', 'Research'],
    notes: 'Long-term customer with analytical needs',
    preferredContact: 'Email',
    timeZone: 'CST',
    birthday: '1983-08-16',
    isSubscribed: true,
    revenue: 165000,
    lastPurchase: '2024-01-13'
  },
  {
    id: 20,
    contactName: 'Jessica Turner',
    firstName: 'Jessica',
    lastName: 'Turner',
    email: 'jessica.turner@fashion.com',
    phone: '+1-555-912-3456',
    mobilePhone: '+1-555-898-7654',
    jobTitle: 'Fashion Designer',
    department: 'Design',
    company: 'Fashion House',
    companySize: 'Small (10-50)',
    industry: 'Fashion',
    address: '789 Style Blvd, New York, NY 10018',
    city: 'New York',
    state: 'New York',
    zipCode: '10018',
    country: 'USA',
    website: 'https://fashion.com',
    linkedin: 'https://linkedin.com/in/jessicaturner',
    status: 'Pending',
    contactType: 'Lead',
    leadSource: 'Email Campaign',
    lastContactDate: '2024-01-20',
    nextFollowUp: '2024-01-27',
    createdAt: '2024-01-04',
    assignedTo: 'Ryan Martinez',
    tags: ['Fashion', 'Design', 'Creative'],
    notes: 'Looking for design collaboration tools',
    preferredContact: 'Phone',
    timeZone: 'EST',
    birthday: '1993-04-07',
    isSubscribed: false,
    revenue: 0,
    lastPurchase: null
  },
  // Adding 80 more contacts to reach 100...
  {
    id: 21,
    contactName: 'Andrew Jackson',
    firstName: 'Andrew',
    lastName: 'Jackson',
    email: 'andrew.jackson@autotech.com',
    phone: '+1-555-123-7890',
    mobilePhone: '+1-555-321-0987',
    jobTitle: 'Automotive Engineer',
    department: 'Engineering',
    company: 'AutoTech Industries',
    companySize: 'Large (500+)',
    industry: 'Automotive',
    address: '123 Motor Way, Detroit, MI 48202',
    city: 'Detroit',
    state: 'Michigan',
    zipCode: '48202',
    country: 'USA',
    website: 'https://autotech.com',
    linkedin: 'https://linkedin.com/in/andrewjackson',
    status: 'Active',
    contactType: 'Customer',
    leadSource: 'Trade Show',
    lastContactDate: '2024-01-24',
    nextFollowUp: '2024-02-01',
    createdAt: '2023-11-20',
    assignedTo: 'Mike Rodriguez',
    tags: ['Automotive', 'Engineering', 'Technical'],
    notes: 'Specialist in electric vehicle technology',
    preferredContact: 'Email',
    timeZone: 'EST',
    birthday: '1984-05-30',
    isSubscribed: true,
    revenue: 190000,
    lastPurchase: '2024-01-15'
  },
  {
    id: 22,
    contactName: 'Sophia Martinez',
    firstName: 'Sophia',
    lastName: 'Martinez',
    email: 'sophia.martinez@biotech.com',
    phone: '+1-555-234-8901',
    mobilePhone: '+1-555-432-1098',
    jobTitle: 'Research Scientist',
    department: 'Research',
    company: 'BioTech Labs',
    companySize: 'Medium (50-200)',
    industry: 'Biotechnology',
    address: '456 Science Park, San Jose, CA 95110',
    city: 'San Jose',
    state: 'California',
    zipCode: '95110',
    country: 'USA',
    website: 'https://biotech.com',
    linkedin: 'https://linkedin.com/in/sophiamartinez',
    status: 'Pending',
    contactType: 'Lead',
    leadSource: 'Research Conference',
    lastContactDate: '2024-01-22',
    nextFollowUp: '2024-01-29',
    createdAt: '2024-01-12',
    assignedTo: 'Dr. Sarah Kim',
    tags: ['Biotech', 'Research', 'Science'],
    notes: 'Working on breakthrough cancer research',
    preferredContact: 'Email',
    timeZone: 'PST',
    birthday: '1987-09-14',
    isSubscribed: true,
    revenue: 0,
    lastPurchase: null
  },
  {
    id: 23,
    contactName: 'Ryan Thompson',
    firstName: 'Ryan',
    lastName: 'Thompson',
    email: 'ryan.thompson@aerospace.com',
    phone: '+1-555-345-9012',
    mobilePhone: '+1-555-543-2109',
    jobTitle: 'Flight Engineer',
    department: 'Engineering',
    company: 'Aerospace Dynamics',
    companySize: 'Large (500+)',
    industry: 'Aerospace',
    address: '789 Sky Drive, Seattle, WA 98109',
    city: 'Seattle',
    state: 'Washington',
    zipCode: '98109',
    country: 'USA',
    website: 'https://aerospace.com',
    linkedin: 'https://linkedin.com/in/ryanthompson',
    status: 'Active',
    contactType: 'Prospect',
    leadSource: 'Industry Event',
    lastContactDate: '2024-01-25',
    nextFollowUp: '2024-02-03',
    createdAt: '2024-01-18',
    assignedTo: 'Captain Jane Wilson',
    tags: ['Aerospace', 'Engineering', 'Aviation'],
    notes: 'Expert in flight control systems',
    preferredContact: 'Phone',
    timeZone: 'PST',
    birthday: '1982-12-08',
    isSubscribed: true,
    revenue: 85000,
    lastPurchase: '2024-01-20'
  },
  {
    id: 24,
    contactName: 'Emma Davis',
    firstName: 'Emma',
    lastName: 'Davis',
    email: 'emma.davis@greentech.com',
    phone: '+1-555-456-0123',
    mobilePhone: '+1-555-654-3210',
    jobTitle: 'Environmental Consultant',
    department: 'Consulting',
    company: 'GreenTech Solutions',
    companySize: 'Small (10-50)',
    industry: 'Environmental',
    address: '321 Eco Lane, Portland, OR 97202',
    city: 'Portland',
    state: 'Oregon',
    zipCode: '97202',
    country: 'USA',
    website: 'https://greentech.com',
    linkedin: 'https://linkedin.com/in/emmadavis',
    status: 'Active',
    contactType: 'Customer',
    leadSource: 'Website',
    lastContactDate: '2024-01-26',
    nextFollowUp: '2024-02-05',
    createdAt: '2023-10-15',
    assignedTo: 'Green Team Lead',
    tags: ['Environmental', 'Sustainability', 'Green'],
    notes: 'Focused on carbon footprint reduction',
    preferredContact: 'Email',
    timeZone: 'PST',
    birthday: '1990-03-25',
    isSubscribed: true,
    revenue: 120000,
    lastPurchase: '2024-01-22'
  },
  {
    id: 25,
    contactName: 'Oliver Smith',
    firstName: 'Oliver',
    lastName: 'Smith',
    email: 'oliver.smith@foodtech.com',
    phone: '+1-555-567-1234',
    mobilePhone: '+1-555-765-4321',
    jobTitle: 'Food Scientist',
    department: 'R&D',
    company: 'FoodTech Innovations',
    companySize: 'Medium (50-200)',
    industry: 'Food & Beverage',
    address: '654 Flavor St, Chicago, IL 60602',
    city: 'Chicago',
    state: 'Illinois',
    zipCode: '60602',
    country: 'USA',
    website: 'https://foodtech.com',
    linkedin: 'https://linkedin.com/in/oliversmith',
    status: 'Pending',
    contactType: 'Lead',
    leadSource: 'Food Expo',
    lastContactDate: '2024-01-21',
    nextFollowUp: '2024-01-28',
    createdAt: '2024-01-10',
    assignedTo: 'Chef Martinez',
    tags: ['Food Science', 'Innovation', 'R&D'],
    notes: 'Developing plant-based alternatives',
    preferredContact: 'Phone',
    timeZone: 'CST',
    birthday: '1985-11-18',
    isSubscribed: false,
    revenue: 0,
    lastPurchase: null
  }
  // ... I'll add the remaining contacts to reach 100, but for brevity, I'll continue with the pattern
];

// Generate remaining 75 contacts programmatically to complete 100
const additionalContacts = [];
for (let i = 26; i <= 100; i++) {
  const firstName = ['John', 'Jane', 'Mike', 'Lisa', 'Tom', 'Sarah', 'Chris', 'Anna', 'David', 'Maria'][i % 10];
  const lastName = ['Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Martinez', 'Hernandez'][i % 10];
  const companies = ['Tech Corp', 'Global Industries', 'Innovation Labs', 'Future Systems', 'Digital Solutions', 'Smart Tech', 'Advanced Corp', 'NextGen Inc', 'Prime Solutions', 'Elite Systems'];
  const industries = ['Technology', 'Finance', 'Healthcare', 'Education', 'Manufacturing', 'Retail', 'Consulting', 'Media', 'Energy', 'Real Estate'];
  const statuses = ['Active', 'Pending', 'Inactive'];
  const contactTypes = ['Customer', 'Prospect', 'Lead'];
  const cities = ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Philadelphia', 'San Antonio', 'San Diego', 'Dallas', 'San Jose'];
  const states = ['NY', 'CA', 'IL', 'TX', 'AZ', 'PA', 'TX', 'CA', 'TX', 'CA'];
  const assignedTo = ['Sales Rep A', 'Sales Rep B', 'Sales Rep C', 'Manager D', 'Lead E'];

  additionalContacts.push({
    id: i,
    contactName: `${firstName} ${lastName}`,
    firstName: firstName,
    lastName: lastName,
    email: `${firstName.toLowerCase()}.${lastName.toLowerCase()}@${companies[i % 10].toLowerCase().replace(' ', '')}.com`,
    phone: `+1-555-${String(i).padStart(3, '0')}-${String(i * 2).padStart(4, '0')}`,
    mobilePhone: `+1-555-${String(i + 100).padStart(3, '0')}-${String(i * 3).padStart(4, '0')}`,
    jobTitle: ['Manager', 'Director', 'VP', 'Analyst', 'Specialist', 'Coordinator', 'Executive', 'Lead', 'Senior', 'Principal'][i % 10],
    department: ['Sales', 'Marketing', 'IT', 'HR', 'Finance', 'Operations', 'Engineering', 'Legal', 'Support', 'Research'][i % 10],
    company: companies[i % 10],
    companySize: ['Small (10-50)', 'Medium (50-200)', 'Large (500+)', 'Enterprise (1000+)'][i % 4],
    industry: industries[i % 10],
    address: `${i * 10} Business St`,
    city: cities[i % 10],
    state: states[i % 10],
    zipCode: String(10000 + i),
    country: 'USA',
    website: `https://${companies[i % 10].toLowerCase().replace(' ', '')}.com`,
    linkedin: `https://linkedin.com/in/${firstName.toLowerCase()}${lastName.toLowerCase()}`,
    status: statuses[i % 3],
    contactType: contactTypes[i % 3],
    leadSource: ['Website', 'LinkedIn', 'Cold Call', 'Referral', 'Trade Show'][i % 5],
    lastContactDate: `2024-01-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    nextFollowUp: `2024-02-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    createdAt: `2023-${String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    assignedTo: assignedTo[i % 5],
    tags: [industries[i % 10], 'Professional', contactTypes[i % 3]],
    notes: `Contact from ${companies[i % 10]} in ${industries[i % 10]} industry`,
    preferredContact: ['Email', 'Phone'][i % 2],
    timeZone: ['EST', 'CST', 'MST', 'PST'][i % 4],
    birthday: `19${80 + (i % 20)}-${String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    isSubscribed: i % 2 === 0,
    revenue: Math.floor(Math.random() * 300000),
    lastPurchase: i % 3 === 0 ? `2024-01-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}` : null
  });
}

// Merge all contacts
export const allContactsData = [...contactsData, ...additionalContacts];

// Additional utility functions for the dataset
export const getContactsByStatus = (status) => {
  return allContactsData.filter(contact => contact.status === status);
};

export const getContactsByType = (type) => {
  return allContactsData.filter(contact => contact.contactType === type);
};

export const getContactsByIndustry = (industry) => {
  return allContactsData.filter(contact => contact.industry === industry);
};

export const getContactsByAssignedTo = (assignedTo) => {
  return allContactsData.filter(contact => contact.assignedTo === assignedTo);
};

export const getTotalRevenue = () => {
  return allContactsData.reduce((total, contact) => total + (contact.revenue || 0), 0);
};

export const getActiveContactsCount = () => {
  return allContactsData.filter(contact => contact.status === 'Active').length;
};

export const getContactsNeedingFollowUp = () => {
  const today = new Date().toISOString().split('T')[0];
  return allContactsData.filter(contact => 
    contact.nextFollowUp && contact.nextFollowUp <= today
  );
};

export const getContactStats = () => {
  return {
    total: allContactsData.length,
    active: getActiveContactsCount(),
    customers: getContactsByType('Customer').length,
    prospects: getContactsByType('Prospect').length,
    leads: getContactsByType('Lead').length,
    totalRevenue: getTotalRevenue(),
    needingFollowUp: getContactsNeedingFollowUp().length
  };
};

export default allContactsData;